/*
 * @Descripttion: 项目入驻申请
 * @Date: 2024-12-02 17:12:49
 */
import { route } from './src/router';

const name = 'project-application';

export { name, route };
